<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/reform',title:'改制单列表'},{title:'新增产品改制'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>改制需求</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="经销商编码" class="h-elformWrap-2" prop="agentCode">
                                                <el-input v-model="f.agentCode" placeholder="请输入" readonly>
                                                    <i class="el-icon-search el-input__icon"
                                                       slot="suffix"
                                                       @click="openAgent">
                                                    </i>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName">
                                                <el-input placeholder="输入经销商编码自动带出" v-model="f.agentName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="区域" class="h-elformWrap-2" prop="areaName">
                                                <brselectlazy category="YLRegion"
                                                              :v="f.areaName"
                                                              v-model="f.areaName"
                                                              :clearable="true" />

                                            </el-form-item>

                                            <el-form-item label="链群" class="h-elformWrap-2" prop="lianqun">
                                                <el-select @change="getLianqun" v-model="f.lianqun" placeholder="请选择" >
                                                    <el-option v-for="item in lianqunList" :key="item.lianqunCode"
                                                               :label="item.lianqunName" :value="item.lianqunCode">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>

                                            <el-form-item label="产品编码" class="h-elformWrap-2" prop="materialCode">
                                                <el-input v-model="f.materialCode" placeholder="请输入" readonly>
                                                    <i class="el-icon-search el-input__icon"
                                                       slot="suffix"
                                                       @click="selectListByCode">
                                                    </i>
                                                </el-input>
                                             </el-form-item>

                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="materialName">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.materialName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="数量" class="h-elformWrap-2" prop="number">
                                                <el-input placeholder="请输入"v-model.number="f.number"></el-input>
                                            </el-form-item>

                                            <el-form-item label="产品大类" class="h-elformWrap-2" prop="oneLName">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.oneLName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="单台加价合计" class="h-elformWrap-2" prop="reformPrice">
                                                <el-input  placeholder="选择改制信息自动计算" v-model="f.reformPrice" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="型号经理工号" class="h-elformWrap-2" prop="typeUserCode">
                                                <el-input placeholder="请输入工号" v-model="f.typeUserCode" :v="f.typeUserCode" oninput="value=value.replace(/[^\d]/g, '')"  @change="checkUser"></el-input>
                                            </el-form-item>
                                            <el-form-item label="型号经理名称" class="h-elformWrap-2" prop="typeUserName">
                                                <el-input placeholder="输入工号自动带出" v-model="f.typeUserName" :v="f.typeUserName"  readonly ></el-input>
                                            </el-form-item>
                                            <el-form-item label="备注" class="h-elformWrap-2" prop="remark">
                                                <el-input  v-model="f.remark" ></el-input>
                                            </el-form-item>


                                            <el-form-item label="附件" class="h-elformWrap-2">
                                                <brupload
                                                        :refid="f.id"
                                                        reftype="附件"
                                                        :uploadflag="true"
                                                        :delflag="true"
                                                        :showtime="false"
                                                        >
                                                </brupload>
                                            </el-form-item>


                                            <div>
                                                <i @click="addSpecific()" style="float:right;font-size:20px;margin-right: 30%" class="el-icon-circle-plus"></i>

<!--                                                 <el-button @click="createSpecific()"  size="mini" class="h-btn h-bBtn h-bgblueQ2"
                                                           style="float:right;margin-right: -20%">新增改制条目</el-button>-->

                                                <div v-for="(listIt, index) in f.specificList" :key="index" class="h-formBox">

                                                    <i @click="deleteSpecific(index)" v-show="index != 0" style="float:right;font-size:20px;margin-right: 30%;color:crimson;"
                                                       class="el-icon-remove"></i>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制目录{{index+1}}
                                                        </template>
                                                        <el-select value-key="id" filterable  v-model="f.specificList[index].specificDivision" placeholder="请选择"  @change="chooseDivision($event,index)">
                                                            <el-option v-for="item in specificDivisionList" :key="item"
                                                                       :label="item.specificDivision" :value="item">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制要求{{index+1}}
                                                        </template>
                                                        <el-select value-key="id" v-if="f.specificList[index].specificType==1" filterable  v-model="f.specificList[index].specificReform" placeholder="请选择"  @change="chooseReform($event,index)" >
                                                            <el-option v-for="item in specificReformList[index]" :key="item.id"
                                                                       :label="item.specificReform" :value="item">
                                                            </el-option>
                                                        </el-select>
                                                        <el-input v-if="f.specificList[index].specificType==2" placeholder="请输入改制要求" v-model="f.specificList[index].specificReform" ></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制数量{{index+1}}
                                                        </template>
                                                        <el-input placeholder="请输入改制数量" v-model="f.specificList[index].reformNum" @change="calReformPrice"></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            单台加价{{index+1}}
                                                        </template>
                                                        <el-input placeholder="由财务填写" v-model="f.specificList[index].reformPrice" readonly></el-input>
                                                    </el-form-item>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </el-form>
                    </div>
                </div>
            </div>
            <!--售达方-->
            <shoudf
                    :visible.sync="showshdfdialog"
                    v-if="showshdfdialog"
                    @choseObj="choseAgent"
                    oneflag
                    :ddlx="1"
                    title="选择售达方"/>
            <!--选择物料-->
           <shouwuliao
                    :visible.sync="xuanwuliao"
                    v-if="xuanwuliao"
                    @choseObj="chanpinxinghaochangetype"
                    :usercode="f.agentCode"
                    oneflag
                    title="选择物料" />
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="saveS('暂存')">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveS('提交')">确认提交</el-button>
             </div>


            <el-dialog :close-on-click-modal="false"  :visible.sync="createSpecificFlag" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>新增改制条目</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <el-form ref="specificForm" :model="createSpecificData" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                        <el-form-item  label="大类编码" class="h-elformWrap-2" label-width="100" prop="oneLId" :rules="[{ required: true, message: '请选择产品大类', trigger: 'blur'},]">
                            <el-select value-key="id" filterable  v-model="createSpecificData.oneLId" placeholder="请选择" @change="getOneLName">
                                <el-option v-for="item in allOne" :key="item.oneLId"  :label="`[${item.oneLId}] ${item.oneLName}`" :value="item.oneLId"  >
                                </el-option>
                            </el-select>

                        </el-form-item>
                        <el-form-item  label="大类名称" class="h-elformWrap-2" label-width="100" prop="oneLName" >
                            <el-input placeholder="输入大类编码自动带出" v-model="createSpecificData.oneLName" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="链群" class="h-elformWrap-2" prop="lianqunCode" :rules="[{ required: true, message: '请选择链群', trigger: 'blur'},]">
                            <el-select v-model="createSpecificData.lianqunCode" placeholder="请选择" @change="getLianqunName">
                                <el-option v-for="item in allLianqun" :key="item.lianqunCode" :label="item.lianqunName" :value="item.lianqunCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="改制目录" class="h-elformWrap-2" prop="specificDivision" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                            <el-select value-key="id"  filterable  v-model="createSpecificData.specificDivision" placeholder="请选择" clearable>
                                <el-option v-for="item in allDivision" :key="item"  :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="改制类型" prop="prodtype" class="h-elformWrap-2">
                            <el-select v-model="createSpecificData.specificType" :clearable="true"
                                       placeholder="请选择">
                                <el-option label="内销" value="1"></el-option>
                                <el-option label="外销" value="2"></el-option>
                                <el-option label="通用" value="3"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="改制要求" class="h-elformWrap-1" prop="specificReform" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                            <el-input placeholder="请输入" v-model="createSpecificData.specificReform" style="width: 84%;"></el-input>
                        </el-form-item>
                        <el-form-item label="单台加价" class="h-elformWrap-2" prop="reformPrice" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                            <el-input placeholder="请输入" v-model.number="createSpecificData.reformPrice" ></el-input>
                        </el-form-item>

                        <el-form-item label="备注" class="h-elformWrap-1"  prop="remark">
                            <el-input v-model="createSpecificData.remark" style="width: 84%;"></el-input>
                        </el-form-item>
                    </el-form>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="closeSpecific">取消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitSpecific()">提交</el-button>
                    </div>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import reformService from "../../../api/reform/reformService.js";
    import specificCatalogue from "../../../api/reform/specificCatalogue.js";
    import shoudf from '../../../components/dialog/selectshdf'
    import shouwuliao from '../../../components/dialog/wxwl-tejia'
    import _ from "loadsh";
    import big from "big.js";

    export default {
        components: {
            shoudf,
            shouwuliao
        },


        data() {
            return {
                xuanwuliao: false,
                showshdfdialog: false,
                createSpecificFlag:false,

                tableData3: [],

                createSpecificData : {
                    oneLId:'', //大类编码
                    oneLName:'',//大类名称
                    lianqunCode:'', //链群编码
                    lianqunName:'',//链群名称
                    specificDivision: '',//改制大类
                    specificReform: '',//改制描述
                    reformPrice:'',//单台加价
                    remark:'', //备注
                    specificType:'1',//改制类型 1-内销，2-外销，3-通用
                },
                //存放所有大类，新增改制条目时用
                allOne:[],
                //存放所有的改制大类，新增改制条目时用
                allDivision:[],
                //存放所有链群，新增改制条目时用
                allLianqun:[],

                //用于存放查询出的改制条目
                specificCatalogueList:[],
                //存放改制目录
                specificDivisionList:[],
                //可选链群
                lianqunList:[],

                specificReformList:[],

                 //带线表单
                f: {
                    id: null,
                    agentCode:null, // 经销商编码
                    agentName:null, // 经销商名称
                    areaCode:null, // 区域编码
                    areaName:null, // 区域名称
                    lianqun:null, // 链群`
                    lianqunName:null, // 链群名称
                    materialCode:null, // 物料编码
                    materialName:null, // 物料名称
                    number:null, // 数量
                 /*   specificIds:null, // 改制大id
                    specificDivisions:null,//改制目录
                    specificReqs:null, // 改制要求*/
                    oneLId:null, // 产品大类编码
                    oneLName:null, // 产品大类名称
                    reformPrice:0, // 定制加价（单台）
                    reformId:null, // 定制编号
                    status:null,
                    typeUserCode:null,
                    typeUserName:null,
                    remark:null,//备注
                    specificList: [{
                        specificId: '',//改制id
                        specificDivision: '',//改制目录
                        specificReform: '',//改制要求
                        reformPrice: '',//单台加价
                        specificType:'',////1目录内改制 2目录外外改制
                        reformNum:1,//改制数量
                    }],

                },
                rules: {

                    agentCode: [{required: true, message: '请选择经销商', trigger: 'blur'}],
                    agentName: [{required: true, message: '请选择经销商', trigger: 'blur'}],
                    areaName: [{required: true, message: '请选择区域', trigger: 'change'}],
                    lianqun: [{required: true, message: '请选择链群', trigger: 'change'}],
                    materialCode: [{required: true, message: '请选择物料', trigger: 'blur'}],
                    materialName: [{required: true, message: '请选择物料', trigger: 'blur'}],
                    number: [{required: true, message: '请填写数量', trigger: 'change'}],
                    oneLName: [{required: true, message: '请填产品大类', trigger: 'change'}],
                    typeUserCode: [{required: true, message: '请填写型号经理工号', trigger: 'change'}],


                },
                typeUserFlag:false,
            }
        },
        created() {
            this.f.id = this.$route.query.ywid || this.$util.getUuid();
            this.query( this.f.id);
        },
        methods: {
            query(id) {
                reformService.selectById(id).then(rd => {
                    if(rd.obj!=null){
                        this.f = rd.obj;
                        this.f.specificList = rd.obj.specificList;

                        if(this.f.oneLId){
                            //查询改制条目
                            this.specificSelectListReload(this.f.oneLId);
                        }

                    }
                })

            },
            //选择经销商
            openAgent() {
                this.showshdfdialog = true;
            },
            //关闭选择经销商
            choseAgent(val) {
                this.showshdfdialog = false;

                this.f.agentName = val.username;
                this.f.agentCode = val.usercode;
                this.f.areaCode = val.area;
                this.f.areaName = val.areaname;
             },
            getOneLName(q){
                //获取name
                const one = _.find(this.allOne,{oneLId:q})

                this.createSpecificData.oneLName = one.oneLName;
                console.log("this.createSpecificData.oneLName",this.createSpecificData.oneLName)
                this.selectAllDivision(q);
             },

            getLianqunName(q){
                //获取name
                const lianqun = _.find(this.allLianqun,{lianqunCode:q})

                this.createSpecificData.lianqunName = lianqun.lianqunName;
                console.log("this.createSpecificData.oneLName",this.createSpecificData.lianqunName)
             },
            //新增改制条目
            createSpecific() {
                 this.createSpecificFlag = true;
                 //查询所有链群
                specificCatalogue.selectAllOne().then(rd => {
                    this.allOne = rd;
                })
            },
            selectAllDivision(oneLId){
                //查询所有改制目录
                specificCatalogue.selectAllDivision({oneLId: oneLId}).then(rd => {
                    this.allDivision = [];
                    for (let item of rd) {
                        if (this.allDivision.indexOf(item.specificDivision) == -1) {
                            this.allDivision.push(item.specificDivision);
                        }
                    }
                     //过滤出所有可选链群
                    this.allLianqun = [];
                    this.createSpecificData.lianqunCode='';
                    this.createSpecificData.lianqunName='';
                    for (let item of rd) {
                        if (this.allLianqun.findIndex(item => item.lianqunCode=== item.lianqunCode) == -1) {
                            this.allLianqun.push(item);
                        }
                    }

                })
            },


            //关闭改制条目
            closeSpecific(){
                this.createSpecificData.oneLId = null;
                this.createSpecificData.oneLName = null;
                this.createSpecificData.lianqunCode = null;
                this.createSpecificData.lianqunName = null;
                this.createSpecificData.specificDivision = null;
                this.createSpecificData.specificReform = null;
                this.createSpecificData.reformPrice = null;
                this.createSpecificData.remark = null;
                this.createSpecificData.specificType = '1';
                this.createSpecificFlag = false;

            },
            //提交改制条目
            commitSpecific(){
                this.$refs['specificForm'].validate((valid0) => {
                    if (valid0) {
                        this.$msg.confirm("确认提交？",()=>{
                            specificCatalogue.insert(this.createSpecificData).then(rd => {
                                this.closeSpecific();
                            })
                        })
                    }else{
                        this.$msg.msge("请完善基本信息后提交");
                        return;
                    }
                });

            },
            //根据大类编码查询改制条目
            specificSelectList(oneLId) {
                 specificCatalogue.selectByOneLId({oneLId: oneLId,specificType:1}).then(rd => {
                     this.specificCatalogueList = rd;
                     //过滤出所有改制目录
                     this.specificDivisionList = [];
                     for (let item of rd) {
                         if (this.specificDivisionList.indexOf(item.specificDivision) == -1) {
                             this.specificDivisionList.push(item.specificDivision);
                         }
                     }
                     //过滤出所有可选链群
                     this.lianqunList = [];
                     this.f.lianqun='';
                     this.f.lianqunName='';
                     for (let item of rd) {
                         if (this.lianqunList.findIndex(item => item.lianqunCode=== item.lianqunCode) == -1) {
                             this.lianqunList.push(item);
                         }
                     }
                     console.log("lianqunList",this.lianqunList);


                 })
            },
            //根据大类编码查询改制条目(此方法用于暂存或者重新提交时查询)
            specificSelectListReload(oneLId) {
                specificCatalogue.selectByOneLId({oneLId: oneLId,specificType:1}).then(rd => {
                    this.specificCatalogueList = rd;
                    //过滤出所有改制目录
                    this.specificDivisionList = [];
                    for (let item of rd) {
                        if (this.specificDivisionList.indexOf(item.specificDivision) == -1) {
                            this.specificDivisionList.push(item.specificDivision);
                        }
                    }
                    //过滤出所有可选链群
                    this.lianqunList = [];
                    for (let item of rd) {
                        if (this.lianqunList.findIndex(item => item.lianqunCode=== item.lianqunCode) == -1) {
                            this.lianqunList.push(item);
                        }
                    }


                    if(this.f.specificList.length>0){
                       for (let i = 0; i < this.f.specificList.length; i++) {
                           this.specificReformList[i] = _.filter(this.specificCatalogueList, {specificDivision: this.f.specificList[i].specificDivision})
                       }
                    }
                })
            },


            //返回
            backS() {
                this.$router.push({path: "/chanp/reform"});
            },
            //提交
            saveS(submitflag) {
                this.f.submitflag = submitflag;
                //如果有流程id则认为是重新提交
                if (this.f.submitflag=='提交' && this.f.instid) {
                    this.f.submitflag = '重新提报'
                }

                var subflag0 = true;
                //校验改制信息是否填写完整
                console.log("this.f.specificList",this.f.specificList)
                this.f.specificList.forEach((item, index) => {
                    if (item.specificType == ''|| item.specificDivision== '' || item.specificReform== '') {
                        this.$msg.msge("请完善改制信息！");
                        subflag0 = false;
                        return false;
                    }
                })
                if(subflag0 ==true){
                    var subflag = false;
                    this.$refs['f'].validate((valid) => {
                        if (valid) {
                            subflag = true;
                        } else {
                            this.$msg.msge("请完善信息后再提交！");
                            return false;
                        }
                    });
                    if (subflag == true) {

                        this.$msg.confirm("确认提交?", () => {
                            /*this.f.specificIds = _.map(this.f.specific, 'id').join("&");
                            this.f.specificDivisions = _.map(this.f.specific, 'specificDivision').join("&");
                            this.f.specificReqs = _.map(this.f.specific, 'specificReform').join("&");*/
                            reformService.submit(this.f).then(rd => {
                                this.$router.push({path: "/chanp/reform"});
                            })
                        });
                    }

                }


            },



            getLianqun(code) {
                this.f.lianqun = code;
                const lianqun = _.find(this.lianqunList,{lianqunCode:code})
                this.f.lianqunName =  lianqun.lianqunName;
            },

            //根据根据编码查询物料信息
            selectListByCode(code) {
                //若已选使用人code
                if (this.f.agentCode) {
                    //弹出物料选择框
                    this.xuanwuliao = true;
                } else {
                    this.$msg.msge("请先选择经销商")
                }
            },
            //选择产品型号的方法
            chanpinxinghaochangetype(val) {
                 //大类名称及编码
                this.f.oneLId = val.cpdlcode;
                this.f.oneLName = val.cpdlname;
                //产品编码及名称
                this.f.materialCode = val.matecode;
                this.f.materialName = val.matedes;
                this.f.typeUserCode = val.typeUserCode;
                if(this.f.typeUserCode != '' && this.f.typeUserCode != null){
                    this.checkUser(this.f.typeUserCode)
                    // this.typeUserFlag = true;
                }else {
                    // this.typeUserFlag = false;
                }
                this.xuanwuliao = false;


                //重新初始化改制条目
                this.f.specificList= [{
                    specificId: '',//改制id
                    specificDivision: '',//改制目录
                    specificReform: '',//改制要求
                    reformPrice: '',//单台加价
                    specificType:'',//1目录内改制 2目录外改制
                    reformNum:1,//改制数量
                }];
                this.specificSelectList(val.cpdlcode);

            },
            //增加一行改制信息
            addSpecific() {
                this.f.specificList.push({
                    specificId: '',//改制id
                    specificDivision: '',//改制目录
                    specificReform: '',//改制要求
                    reformPrice: '',//单台加价
                    specificType:'',//1目录内改制 2目录外改制
                    reformNum: 1,//改制数量
                })
            },
            //减少一行改制信息
            deleteSpecific(index) {
                this.f.specificList.splice(index, 1)

            },
            //选择改制目录
            chooseDivision(specificDivision,index){
                 this.specificReformList[index] = _.filter(this.specificCatalogueList, {specificDivision: specificDivision})

                this.f.specificList[index].specificId = null;
                this.f.specificList[index].specificReform = null;
                this.f.specificList[index].reformPrice = null;
                this.f.specificList[index].reformNum = 1;
                if(specificDivision=='改制目录外'){
                    this.f.specificList[index].specificType = 2;
                }else{
                    this.f.specificList[index].specificType = 1;
                }
            },

            //选择改制要求
            chooseReform(specific,index){
                this.f.specificList[index].specificId = specific.id;
                this.f.specificList[index].specificReform = specific.specificReform;
                this.f.specificList[index].reformPrice = specific.reformPrice;

            },
            //重新计算单台加价
            /*  countReformPrice(){
                  this.f.reformPrice ='';
                  for (var i = 0; i < this.f.specificList.length; i++) {

                      if (this.f.reformPrice != null && this.f.reformPrice != '') {
                          this.f.reformPrice = this.f.reformPrice +  this.f.specificList[i].reformPrice;
                      } else {
                          this.f.reformPrice = this.f.specificList[i].reformPrice;
                      }
                  }
            },*/

        //检查用户是否存在
            checkUser(code){
                ss.UserService.selectById(code).then(rd => {
                    if(rd.obj==null){
                        this.$msg.msge("该型号经理在系统中不存在！");
                        this.f.typeUserCode ='';
                    }else{
                        this.f.typeUserName =rd.obj.username;
                        this.f.typeUserCode =code;
                    }
                })
            },
            calReformPrice(){

            },
        },

        watch: {
            'f.specificList': {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    //计算总金额
                    // this.f.reformPrice = _.reduce(_.map(newValue, "reformPrice"), function (sum, v) {
                    //     return new big(sum).plus(v||0).toString();
                    // }, 0)
                    var reformPrice = 0;
                    for(var i = 0;i<newValue.length;i++){
                        reformPrice += newValue[i].reformPrice?newValue[i].reformPrice* newValue[i].reformNum:0;
                    }
                    this.f.reformPrice = reformPrice;
                },


            },
        },
    }
</script>
<style>
    .Yangbiao .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    .Yangbiao .el-form-item__content {
        width: 55%;
    }

    .Yangbiao .h-elformWrap-2 {
        width: 25% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-3 {
        width: 85% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-3 .el-form-item__label {
        width: 12%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-4 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-4 .el-form-item__label {
        width: 10%;
    }
    .Yangbiao .h-elformWrap-4 .el-form-item__content {
        width: 89%;
    }
    .Yangbiao .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .Yangbiao .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .Yangbiao.el-form-item__content .el-select {
        width: 100%;
    }
</style>
